import React from 'react';
import PropTypes from 'prop-types';
import css from './BatchSentItemStats.scss';

export default class BatchSentItemStats extends React.Component {

  render() {
    return (
      <div className={css['batch-send-item-stats']}>
        {this.props.numberOfItems} Items in the last {this.props.timeRange} days
      </div>
    );
  }

}

BatchSentItemStats.propTypes = {
  numberOfItems: PropTypes.number.isRequired,
  timeRange: PropTypes.number.isRequired
}
